<template>
  <div style="padding-top: 32px;">
    <component :is="viewComponent" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('dashboard', ['isDelivery']),
    viewComponent () {
      return this.isDelivery
        ? () => import('./ForDelivery')
        : () => import('./ForCompany')
    }
  }
}
</script>
